import { performRequest } from "../performRequest"



export const getAllResignationsApi = (params) => {
    return performRequest("get", "api/ess/resignation/",params)
}

export const getResignationDetailApi = (id, params) => {
    return performRequest("get", `api/ess/resignation/${id}/`,params)
}

export const updateResginationApi = (id, params) => {
    return performRequest("patch", `api/ess/resignation/${id}/`,params)
}

export const createResginationApi = (params) => {
    return performRequest("post", `api/ess/resignation/`,params)
}

export const approveResginationApi = (id, params) => {
    return performRequest("patch", `api/ess/resignation/${id}/`,params)
}